import { PackageProviderName, SettingKey } from 'data/ppoints/constants';
import useSettings from 'hooks/useSettings';
import { ProviderToCountrySetting } from 'models/ppoints/settings/SettingsToEcom';
import { useMemo } from 'react';

export interface FirstSelectedProvider {
    provider?: PackageProviderName;
    /** Every distinct active carrier, in `provider_to_country` order */
    providers: PackageProviderName[];
    /** Number of distinct active carriers */
    activeCount: number;
    /** The country each active carrier was first activated in — the provider settings route is keyed on it */
    countryByProvider: Partial<Record<PackageProviderName, string>>;
}

/** The first activated provider from `provider_to_country`, plus how many distinct providers are activated */
export const useFirstSelectedProvider = (): FirstSelectedProvider => {
    const { settings: providerToCountry } = useSettings<ProviderToCountrySetting>(SettingKey.provider_to_country);

    return useMemo(() => {
        const countryByProvider: Partial<Record<PackageProviderName, string>> = {};

        Object.entries(providerToCountry ?? {}).forEach(([country, providers]) =>
            (providers ?? []).filter(Boolean).forEach((provider) => {
                countryByProvider[provider] ??= country;
            })
        );

        const selected = Object.keys(countryByProvider) as PackageProviderName[];

        return { provider: selected[0], providers: selected, activeCount: selected.length, countryByProvider };
    }, [providerToCountry]);
};
